import { Link } from "@tanstack/react-router"

import { useSignupLink } from "@/components/account/useSignupLink"

export function CreateAccountLink({ slug }: { slug?: string }) {
  const toSignupOptions = useSignupLink(slug)

  if (!toSignupOptions) {
    return null
  }

  return (
    <p className="w-full text-lg text-neutral-500">
      {"Don't have an account? "}
      <Link className="underline" {...toSignupOptions}>
        Create now
      </Link>
    </p>
  )
}
